import { Outlet } from "react-router-dom";

/**
 * Main application layout template.
 * Wraps all routed pages with a consistent structure.
 * Pages control their own backgrounds and layout.
 */
export function MainLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
